{
  "admin-hub.ci-test.message-template-template-hello-world": "{propA}，您好！是一個可愛的 {propB}",
  "ci-generation.email.body": "這是來自 {env} 環境的測試訊息。",
  "ci-generation.email.body.hello": "{name}，您好！",
  "ci-generation.email.body.img.alt": "這是圖像的替代文本",
  "ci-generation.email.body.regards": "郵局團隊",
  "ci-generation.email.body.signoff": "謝謝，",
  "ci-generation.email.subject": "Post Office 的「{env}」測試訊息",
  "ci-generation.email.unsubscribe.text": "取消訂閱",
  "post-office.test-message.email.subject": "Post Office 的「{env}」測試訊息",
  "post-office.test-slack-notification.sample-hello-message": "您好，* 這是郵局的通知測試 *",
  "product-store-personal-use-case.hello-world": "您好！是一個可愛",
  "test-messages.app-switcher-discovery-section.dismiss": "關閉",
  "test-messages.app-switcher-discovery-section.test-content": "這是測試訊息",
  "test-messages.email.body.regards": "郵局團隊",
  "test-messages.in-app-example.hello-world": "{propA}，您好！是一個可愛的 {propB}",
  "test-messages.jira-navigation-topbar-edition-awareness.hello-world": "{propA}，您好！是一個可愛的 {propB}",
  "test-messages.redacted-email.body.regards": "郵局團隊",
  "test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt": "圖片描述",
  "test-messages.test-message-grouped-recipients.message-template.email.subject": "Post Office 的「{env}」測試訊息",
  "test-messages.test-message-grouped-recipients.test-message.email.body": "這是來自 {env} 環境的測試訊息。",
  "test-messages.test-message-grouped-recipients.test-message.email.body.hello": "您好",
  "test-messages.test-message-grouped-recipients.test-message.email.body.regards": "郵局團隊",
  "test-messages.test-message-grouped-recipients.test-message.email.body.signoff": "謝謝，",
  "test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text": "取消訂閱",
  "test-messages.test-message-persona-email.message-template-template.email.body.img.alt": "圖片描述",
  "test-messages.test-message-persona-email.message-template.email.subject": "Post Office 的「{env}」測試訊息",
  "test-messages.test-message-persona-email.test-message.email.body": "這是來自 {env} 環境的測試訊息。",
  "test-messages.test-message-persona-email.test-message.email.body.regards": "郵局團隊",
  "test-messages.test-message-persona-email.test-message.email.body.signoff": "謝謝，",
  "test-messages.test-message-persona-email.test-message.email.unsubscribe.text": "取消訂閱",
  "test-messages.test-message.email.body": "這是來自 {env} 環境的測試訊息。{additionalBody}",
  "test-messages.test-message.email.body.hello": "嗨阿特拉西安，",
  "test-messages.test-message.email.body.img.alt": "這是測試消息-電子郵件消息模板的 alt",
  "test-messages.test-message.email.body.signoff": "謝謝，",
  "test-messages.test-message.email.unsubscribe.text": "取消訂閱",
  "test-messages.test-message.redacted-email.body": "這是來自 {env} 環境的測試電子郵件消息的編輯版本。 {additionalBody}",
  "test-messages.test-message.redacted-email.body.hello": "嗨阿特拉西安，",
  "test-messages.test-message.redacted-email.body.img.alt": "這是測試消息-電子郵件消息模板的 alt",
  "test-messages.test-message.redacted-email.body.signoff": "謝謝，",
  "test-messages.test-message.redacted-email.unsubscribe.text": "取消訂閱",
  "wac-global-nav-product-recommendation.hello-world": "您好！是一個可愛"
}